import { cn } from '@/ui/lib/utils'

export interface QuantCliPreviewProps {
  slug: string
  /** The flag portion of the command (already formatted), e.g. `--k 2 --no-x`. */
  flags: string
  /** When true the line shown is the last valid one, dimmed, with an `invalid params` marker. */
  invalid?: boolean
}

/**
 * The CLI preview block (spec 036 handoff 3.3): an ink block with an accent
 * `$ ` prompt and `python strategies/{slug}/run.py` plus flags.
 */
export function QuantCliPreview({ slug, flags, invalid = false }: QuantCliPreviewProps) {
  return (
    <div
      data-quant-cli
      className="bg-ink px-3 py-2.5 font-mono text-[11.5px] leading-[1.65] text-paper-90 [word-break:break-word]"
    >
      <span className={cn(invalid && 'opacity-45')}>
        <span className="text-accent-line">$ </span>
        {`python strategies/${slug}/run.py${flags ? ` ${flags}` : ''}`}
      </span>
      {invalid && (
        <span role="status" className="ml-3 text-[10px] tracking-[0.14em] text-alert uppercase">
          invalid params
        </span>
      )}
    </div>
  )
}
